import React            from 'react';
import PropTypes        from 'prop-types';
import Tippy            from '@tippyjs/react';
import classNames       from 'classnames';
import 'tippy.js/dist/tippy.css';
import 'tippy.js/themes/light.css';
// import useMessage      from './useHeader';


import styles           from './Tooltip.styl';

function CommonTooltip(props) {
    const {
        className,
        children,
        content,
        placement,
        ...rest
    } = props;

    // const {} = useMessage();

    return  (
        <Tippy
            content   = {content}
            className = {classNames(styles.Tooltip, className)}
            arrow     = {true}
            placement = {placement}
            theme     = 'light'
            {...rest}
        >
            {children}
        </Tippy>
    );
}

CommonTooltip.propTypes = {
    className : PropTypes.string,
    children  : PropTypes.node.isRequired,
    content   : PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.node
    ]),
    placement  : PropTypes.string
};

CommonTooltip.defaultProps = {
    className : '',
    content   : '',
    placement  : 'right'
};

export default CommonTooltip;
